<template>
    <v-expansion-panels accordion class="mb-2" v-model="panel">
        <v-expansion-panel>
            <v-expansion-panel-header>
                <h3 class="d-flex align-center" style="height: 36px">
                    <div class="flex-grow-1">{{ $translate(title) }}</div>
                    <div v-if="actions">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon color="primary">mdi-dots-horizontal-circle-outline</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="action.action" v-for="(action, index) in actions" :key="index">
                                    <v-list-item-title>{{ action.title }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </h3>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <hr class="mb-6 mx-n6"/>
                <slot name="content"></slot>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: 'zoezi-collapsible-card',
    props: {
        title: {
            type: String,
        },
        actions: {
            type: Array
        }
    },

    data: () => ({
        panel: 0
    })
};
</script>
